



























import { DateTime } from "luxon";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";

@Component({
  components: {
    DateField,
    TimeField,
  },
})
export default class DateTimeOffsetField extends Vue {
  // input/output is ISO format string
  @Prop({ default: "" }) value!: string;
  @Prop() dateLabel?: string;
  @Prop() timeLabel?: string;

  @Prop({ default: false }) clearable?: boolean;
  @Prop() dense?: boolean;
  @Prop({ default: false }) outlined?: boolean;
  @Prop() disabled?: boolean;
  @Prop() readonly?: boolean;

  @Prop({ default: "6-6" }) sizes!: string;

  // input/output type
  @Prop({ default: "utc" }) type!: "utc" | "local";

  // validation
  @Prop() required?: boolean;
  @Prop({ default: () => [] }) rules?: any[];

  internalValue = "";

  @Watch("value", { immediate: true })
  inputValueChanged(fresh: string | undefined | null) {
    if (fresh) {
      this.internalValue = fresh;
      this.dateInternal = this.datePart;
      this.timeInternal = this.timePart;
    } else {
      if (this.internalValue) {
        this.dateInternal = "";
        this.timeInternal = "";
      }
      this.internalValue = "";
    }
  }

  @Watch("internalValue")
  internalValueWatch(fresh: string, old: string) {
    if (fresh !== old) {
      this.$emit("input", this.internalValue);
    }
  }

  get dateTime() {
    if (!this.internalValue) return null;
    const dateTime = DateTime.fromISO(this.internalValue, { zone: this.type });
    return dateTime.toLocal();
  }

  dateInternal = "";
  get datePart() {
    return this.dateTime?.toISO().substring(0, 10) ?? this.dateInternal;
  }

  set datePart(value: string) {
    this.dateInternal = value;

    if (this.dateInternal && this.timeInternal) {
      const localISO = this.dateInternal + "T" + this.timeInternal;
      this.setValue(localISO);
    } else {
      this.internalValue = "";
    }
  }

  timeInternal = "";
  get timePart() {
    return this.dateTime?.toISO().substring(11, 16) ?? this.timeInternal;
  }

  set timePart(value: string) {
    this.timeInternal = value;

    if (this.dateInternal && this.timeInternal) {
      const localISO = this.dateInternal + "T" + this.timeInternal;
      this.setValue(localISO);
    } else {
      this.internalValue = "";
    }
  }

  setValue(localISO: string) {
    let newDateTime = DateTime.fromISO(localISO);
    if (this.type === "utc") newDateTime = newDateTime.toUTC();
    this.internalValue = newDateTime.toISO();
  }

  internalValidation = {
    required: (value: any) => !!value || this.$t("Validation.Required"),
  };

  get _dateLabel() {
    if (!this.dateLabel) return "";
    return this.dateLabel + (this.required ? "*" : "");
  }

  get _timeLabel() {
    if (!this.timeLabel) return "";
    return this.timeLabel + (this.required ? "*" : "");
  }

  get dateSize() {
    return this.sizes.split("-")[0];
  }
  get timeSize() {
    return this.sizes.split("-")[1];
  }
}
